forestControllers.controller('sbInputController', function ($scope, _, Server, dialogs, existingData, notifications) {
    //$scope.currentlyEditing = $stateParams.num;

    $scope.share = {};

    console.log('xisDiametris: ', $scope.xisDiametris);

    $scope.agmonaceniMdgomareobaDropdown = [{value: 0, label: 'არადამაკმაყოფილებელი'},
        {value: 1, label: 'დამაკმაყოფილებელი'}];

    $scope.userInput = existingData ? existingData : {};
    //$scope.userInput.maketi2 = {};

    $scope.sbSubmit = function () {

        var data = getMergedData();

        Server.saveSb(data).then(function (res) {
            //dialogs.notify("ბარათი შენახულია", "სატაქსაციო ბარათი წარმატებით განახლდა");
            notifications.showSuccess({message: "სატაქსაციო ბარათი წარმატებით განახლდა", hideDelay: 3000, hide: true});
            $scope.sbForm.$setPristine();

        }).catch(function (res) {

            var errors = '';
            console.log('errors', res);

            _.each(res.data.invalidFields, function (elem) {

                _.each(elem, function (particular_error) {

                    errors += ' - ' + particular_error + '<br>';
                });
            });

            notifications.showError({message: "შენახვისას დაფიქსირდა შეცდომა <br>" + errors});
            //dialogs.error("ბარათი ვერ განახლდა", "შეამოწმეთ ინტერნეტთან კავშირი <br>" + errors);
        });
    };

    $scope.nextLiteri = function () {

        var data = getMergedData();

        Server.saveSb(data).then(function (res) {
            $scope.sbForm.$setPristine();
            $scope.barati.locations.literi++;
        }).catch(function () {
            dialogs.error("ბარათი ვერ განახლდა", "შეამოწმეთ ინტერნეტთან კავშირი");
        });
    };

    $scope.previousLiteri = function () {
        $scope.barati.locations.literi--;
    };

    function getMergedData() {

        var data = angular.merge($scope.userInput, $scope.barati.locations);

        return data;
    }

    $scope.pad = function (num, size) {
        var s = num + "";
        while (s.length < size) s = "0" + s;
        return s;
    };
});

/**
 * Here we create kind of abstract controller for each maketi controller.
 * And define what is common for each of them. Then we extend each controller below.
 */
angular.forEach(['1', '2', '3', '4', '5', '10', '12', '28', '31', '32', '36', '39'], function (num) {

    var self = this;

    forestControllers.controller('m' + num + 'Controller', function ($scope, $controller) {
        $scope.userInput['maketi' + num] = !$scope.userInput['maketi' + num] ? {} : $scope.userInput['maketi' + num];
        $scope.userInput['maketi' + num]._disabled = false;

        $scope.self = $scope.userInput['maketi' + num];

        $scope.getPanelClass = function () {

            var form = $scope['maketi' + num];

            if (!form) {
                return 'panel-danger';
            }

            if (form.$error.required && _.size(form.$error) == 1) {
                return 'panel-warning';
            } else if (form.$error.required ? _.size(form.$error) > 1 : _.size(form.$error) > 0) {
                return 'panel-danger';
            } else {
                return 'panel-success';
            }
        };

        if (self['Maketi' + num + 'Controller']) {
            angular.extend(this, $controller(self['Maketi' + num + 'Controller'], {$scope: $scope}));
        }
    });
});

var micis_qvekategoria_sets = {
    set_1: [1101, 1102, 1103, 1104, 1105, 1106, 1108, 1109, 1204]
};

function Maketi1Controller($scope, _, notifications) {

    function updateRequirements() {

        var contains = _.contains(micis_qvekategoria_sets.set_1, $scope.self.micis_qvekategoria_id);

        $scope.eqspozicia_id_required = contains;
        $scope.daqaneba_id_required = contains;
        $scope.szd_id_required = contains;
    }

    $scope.$watch(function () {
        return $scope.self.micis_qvekategoria_id;
    }, updateRequirements);

    $scope.$watch(function () {
        return $scope.self.daqaneba_id;
    }, function (daqaneba_id) {

        console.log(daqaneba_id);

        if (daqaneba_id == 8) {


            if ($scope.self.gfdu_id != 7) {
                notifications.showSuccess({
                    message: 'გ.ფ.დ.უ. შეიცვალა: <stron>' + 7 + '</strong>',
                    hideDelay: 5000,
                    hide: true
                });
                $scope.self.gfdu_id = 7;
            }
        }
    });
}

function Maketi3Controller($scope, _) {
    $scope.userInput.maketi3._disabled = false;
    $scope._ = _;

    function updateRequirements() {
        $scope.all_fields_required = _.contains(micis_qvekategoria_sets.set_1, $scope.userInput.maketi1.micis_qvekategoria_id);
    }

    $scope.$watch('userInput.maketi1.micis_qvekategoria_id', updateRequirements);

}

function Maketi10Controller($scope, _, notifications, m10) {

    m10.init($scope.sbXisSaxeobas, $scope.bonitetisCxriliItems, $scope.sbMaragisCxrilis);

    $scope._ = _;

    $scope.m10_factory = {};

    var m10_factory_keys = [
        'iarusi_id',
        'coef',
        'saxeoba_id',
        'celi',
        //TODO: Reenable these when lists for them are ready.
        //'diametri_id',
        'simagle',
        'sasaqonlo_klasi_id',
        'koromis_carmoshoba_id',
        'sixshire',
        //'ganivkvetis_fartobi',
        //'maragi'
    ];

    $scope.userInput.maketi10 = !$scope.userInput.maketi10 ? {} : $scope.userInput.maketi10;

    $scope.userInput.maketi10.iarusis =
        !$scope.userInput.maketi10.iarusis ? {} : $scope.userInput.maketi10.iarusis;

    //$scope.userInput.maketi10.iarusis.items =
    //!$scope.userInput.maketi10.iarusis.items ? [] : $scope.userInput.maketi10.iarusis.items;

    /**
     * Create list of available simagles in maragis table for each saxeoba
     * @type {Array}
     */

    $scope.maketi10_simaglesBySaxeoba = [];

    _.each($scope.sbXisSaxeobas, function (itm) {
        var found = _.where($scope.sbMaragisCxrilis, {sb_maragis_cxrili_saxeoba_id: itm.sb_maragis_cxrili_saxeoba_id});
        found = found ? found : [];

        $scope.maketi10_simaglesBySaxeoba[itm.id] = _.pluck(found, 'simagle');
    });

    /**
     * Create list of available asakis in bonitetis table for each saxeoba
     * @type {Array}
     */

    $scope.maketi10_asakisBySaxeoba = [];

    _.each($scope.sbXisSaxeobas, function (itm) {
        var found = _.where($scope.bonitetisCxriliItems, {bonitetis_cxrili_id: itm.bonitetis_cxrili_id});
        found = found ? found : [];

        $scope.maketi10_asakisBySaxeoba[itm.id] = _.uniq(_.pluck(found, 'asaki'));
    });

    $scope.$watchCollection(function () {
        return $scope.m10_factory;
    }, function () {
        /**
         * Remove 'missing' validation error from each m10 factory input.
         * when user starts typing again.
         */
        _.each(m10_factory_keys, function (key) {
            $scope.maketi10_item_form[key]
                .$setValidity("missing", true);
        });
    });

    function requiresManualMaragi() {
        return [9, 13, 15].indexOf($scope.m10_factory.iarusi_id) !== -1;
    }

    function getFieldRequirements() {

        var isMomcifari = isMomcifariFactory($scope.m10_factory, $scope.sbXisSaxeobas);
        var gonisdzieba = getGonisdziebaQvekategoria($scope.userInput.maketi2.gonisdzieba1_id);
        var gonisdzieba_qvekategoria_id = gonisdzieba && gonisdzieba.id;

        var hasMomcifari = false;
        var selectedIarusi = $scope.userInput.maketi10.iarusis[$scope.m10_factory.iarusi_id];
        var esentialsAndMaragi = [9, 13, 15].indexOf($scope.m10_factory.iarusi_id) !== -1;

        /**
         * If selected iarusi exists in list.
         */
        if (selectedIarusi) {
            hasMomcifari = !!m10.getMomcifari(selectedIarusi);
        }

        return {
            sixshire : (!selectedIarusi || !selectedIarusi.sixshire) && !esentialsAndMaragi,
            celi : ($scope.m10_factory.coef != 0 && !hasMomcifari) || esentialsAndMaragi,
            simagle : ($scope.m10_factory.coef != 0 && !hasMomcifari) || esentialsAndMaragi,
            diametri : ($scope.m10_factory.coef != 0 && !hasMomcifari) || esentialsAndMaragi,
            sasaqonlo_klasi_id : (isMomcifari || gonisdzieba_qvekategoria_id == 2 ) && $scope.m10_factory.coef != 0,
            koromis_carmoshoba_id : (isMomcifari || gonisdzieba_qvekategoria_id == 2 ) && $scope.m10_factory.coef != 0,
            maragi : esentialsAndMaragi
        };
    }

    function getUnneededFileds(){

        var out = [];
        var fields = getFieldRequirements();

        _.each(fields, function(val, filed){
            !val && out.push(filed);
        });

        console.log('getUnneededFileds: ', out);

        return out;
    }

    function setRequirements() {

        _.each(getFieldRequirements(), function(item, key){
            $scope[key + '_required'] = item;
        });
    }

    $scope.addItem = function () {

        $scope.maketi10_item_form.$setSubmitted();

        if ($scope.maketi10_item_form.$invalid) {
            return;
        }

        var item = _.clone($scope.m10_factory);

        console.log('item after removed unneded files.', item);

        item = _.remove(item, getUnneededFileds());

        console.log('item after removed unneded files.', item);

        if (!$scope.userInput.maketi10.iarusis[item.iarusi_id]) {
            $scope.userInput.maketi10.iarusis[item.iarusi_id] = {};
        }

        if (!$scope.userInput.maketi10.iarusis[item.iarusi_id].items) {
            $scope.userInput.maketi10.iarusis[item.iarusi_id].items = [];
        }

        /**
         * Sixshire for particular iarusi is asked only once from user.
         */
        if (!$scope.userInput.maketi10.iarusis[item.iarusi_id].sixshire) {
            $scope.userInput.maketi10.iarusis[item.iarusi_id].sixshire = item.sixshire;
        }

        if (!$scope.userInput.maketi10.iarusis[item.iarusi_id].iarusi_id) {
            $scope.userInput.maketi10.iarusis[item.iarusi_id].iarusi_id = item.iarusi_id;
        }

        /**
         * If no maragi provided this is true in most cases.
         * But sometimes people provide it manually for particular type of iarusi
         */
        if (!item.maragi) {

            /**
             * We skip these steps for trees with plus
             */
            if(item.coef > 0) {

                var iarusi = $scope.userInput.maketi10.iarusis[item.iarusi_id];

                var sixshire = iarusi.sixshire;

                var momcifari = m10.getMomcifari(iarusi);

                /**
                 * If iarusi already contains item that is higher than momcifari, then we
                 * don't ask user for celi, simagle, asaki and take these values
                 * from that momcifari, but thing is that tables of new saxeoba may not match
                 * values that were taken from momcifari and thus we keep these in boundaries.
                 */
                if (momcifari) {

                    item.celi = momcifari.celi;
                    item.simagle = momcifari.simagle;
                    item.diametri = momcifari.diametri;

                    m10.boundItemProperties(item);

                }

                /**
                 * Maragi can be manually provided for particular
                 */
                if(!requiresManualMaragi(iarusi)){
                    var maragi = m10.getItemMaragi(item, sixshire);

                    /**
                     * Check if saxeoba has maragis cxrili assigned
                     */
                    if (maragi) {
                        item.maragi = maragi;
                    } else {
                        $scope.maketi10_item_form.$setValidity(false);
                        notifications.showError('მარაგის ცხრილი არ არის შერჩეული.');
                        return;
                    }
                }
            }
        }

        $scope.userInput.maketi10.iarusis[item.iarusi_id].items.push(item);

        /**
         * Reset factory form. But keep iarusi chosen.
         */
        $scope.m10_factory = {iarusi_id: $scope.m10_factory.iarusi_id};
        $scope.maketi10_item_form.$setPristine();

        handleM10ItemChange();
    };

    $scope.removeItem = function (item) {

        _.each($scope.userInput.maketi10.iarusis, function (iarusi, key) {
            var index = iarusi.items.indexOf(item);

            if (index !== -1) {
                iarusi.items.splice(index, 1);
            }
        });

        /**
         * Remove iarusis that have empty item list.
         */
        var keys = [];
        _.each($scope.userInput.maketi10.iarusis, function (iarusi, key) {

            if (iarusi.items.length < 1) {
                keys.push(key);
            }
        });

        for (var i = 0; i < keys.length; i++) {
            delete $scope.userInput.maketi10.iarusis[keys[i]];
        }

        /**
         * WARNING: It's important to run this after empty iarusis where removed.
         */
        handleM10ItemChange();
    };

    function handleM10ItemChange() {

        updateItemOrder();

        var gabatonebuliSaxeoba = m10.determineGabatonebuiSaxeoba($scope.userInput.maketi10.iarusis);

        /**
         * Reference for UI.
         */
        $scope._gabatonebuliIarusi = m10.determineGabatonebuliIarusi($scope.userInput.maketi10.iarusis);

        if (gabatonebuliSaxeoba) {

            /**
             * Used m10 table template to indicate gabatonebuli saxeoba.
             */
            $scope._gabatonebuli = gabatonebuliSaxeoba;

            setGabatonebuliSaxeoba(gabatonebuliSaxeoba);

            var boniteti = m10.determineBoniteti(gabatonebuliSaxeoba);

            boniteti && setBoniteti(boniteti);
        }

        updateKoefSum();
        updateIarusiSixshires();
    }

    function updateItemOrder() {

        /**
         * Assign sum to each iarusi
         */

        _.each($scope.userInput.maketi10.iarusis, function (iarusi) {

            return iarusi.sum = _.reduce(iarusi.items,
                function (memo, itm) {
                    return memo + parseInt(itm.maragi);
                }, 0);
        });

        /**
         * This is what is shown to user.
         */
        $scope.viewItems = _.sortBy($scope.userInput.maketi10.iarusis, 'sum').reverse();
    }

    $scope.getPanelClass = function () {

        if (_.size($scope.userInput.maketi10.iarusis) <= 0) {
            return 'panel-warning';
        }

        return isMaketi10Valid() ? 'panel-success' : 'panel-danger';
    };

    function isMaketi10Valid() {

        return _.reduce($scope.coefSum, function (memo, itm) {
            return memo && itm == 10
        }, true);

    }

    $scope.coefSum = 0;

    /**
     * Update m10 item coefs that to determine how much
     * coefs can be added additionally. And update UI.
     */
    function updateKoefSum() {
        /**
         * Make sum of existing 10_item coefs
         */

        $scope.coefSum = m10.getIarusiCoefSums($scope.userInput.maketi10.iarusis);
    }

    /**
     * Show appropriate list of sasaqonlo klasi depending on
     * saxeobas xis_tipi (wiwvovani | fotlovani)
     */
    $scope.$watch(function () {
        return $scope.m10_factory.saxeoba_id;
    }, function () {

        var saxeoba = _.findWhere($scope.sbXisSaxeobas, {id: $scope.m10_factory.saxeoba_id});

        $scope.filteredSasaqonloKlasis = saxeoba ?
            _.where($scope.sasaqonloKlasis, {xis_tipi_id: saxeoba.xis_merqnis_tipi.xis_tipi.id}) : {};

    });

    $scope.need_all_fields = true;

    $scope.$watchCollection('m10_factory', setRequirements);
    $scope.$watchCollection('userInput.maketi2', setRequirements);

    function getGonisdziebaQvekategoria(gonisdzieba_id) {

        var gonisdzieba = _.findWhere($scope.gonisdziebas, {id: gonisdzieba_id});

        return gonisdzieba && gonisdzieba.gonisdzieba_qvekategoria;
    }

    function isMomcifariFactory(factory, sbXisSaxeobas) {

        if (factory.saxeoba_id && factory.celi) {

            var saxeoba = _.findWhere(sbXisSaxeobas, {id: factory.saxeoba_id});

            return m10.isMomcifari(saxeoba, factory.celi);
        }

        return false;
    }

    function setGabatonebuliSaxeoba(item) {

        var saxeoba = _.findWhere($scope.sbXisSaxeobas, {id: item.saxeoba_id});

        notifications.showSuccess({
            message: 'გაბატონებული სახეობა შეიცვალა: <stron>' + saxeoba.label + '</strong>',
            hideDelay: 5000,
            hide: true
        });

        $scope.userInput.maketi3.gabatonebuli_saxeoba_id = saxeoba.id;

    }

    function setBoniteti(boniteti) {

        var boniteti_object = _.findWhere($scope.bonitetis, {id: boniteti.boniteti_id});

        notifications.showSuccess({
            message: 'ბონიტეტი შეიცვალა: <stron>' + boniteti_object.label + '</strong>',
            hideDelay: 0,
            hide: true
        });

        $scope.userInput.maketi3.boniteti_id = boniteti.boniteti_id;

    }

    function updateIarusiSixshires() {
        $scope.iarusiSixshires = m10.getSixshireLeftover($scope.userInput.maketi10.iarusis);
    }

    updateIarusiSixshires();
    handleM10ItemChange();

}

function Maketi31Controller($scope, _) {

    $scope.$watchCollection(function () {
        return $scope.userInput.maketi31;
    }, function () {

        /**
         * Validate if all coef sums equals 10.
         * Show validation errors
         */
        var valid = !_.isUndefined($scope.userInput.maketi31.coef1) && !_.isUndefined($scope.userInput.maketi31.coef2) && !_.isUndefined($scope.userInput.maketi31.coef3) && ($scope.userInput.maketi31.coef1 +
            $scope.userInput.maketi31.coef2 +
            $scope.userInput.maketi31.coef3 ) != 10;

        _.each(['coef1', 'coef2', 'coef3'], function (key) {
            $scope.maketi31[key].$setValidity('coef', !valid);
        });
    });
}

function Maketi39Controller($scope, _) {

    $scope.$watch(function () {
        return $scope.userInput.maketi39.ant_trans_tipi_id
    }, function (val) {

        $scope.filteredAntTransXarixis = _.where($scope.antTransXarisxis,
            {ant_trans_tipi_id: val});
    });
}